var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"title":_vm.formattedValue},on:{"click":function($event){_vm.selectCell($event.currentTarget, _vm.columnKey)}}},[_vm._v("\r\n    "+_vm._s(_vm.formattedValue)+"\r\n")])}
var staticRenderFns = []

export { render, staticRenderFns }